import http from 'core/http-common'

import {
  IFilteredMeetingRoomList,
  IGetMeetingRoomTimeTableReq,
  IMeetingRoomFilteredReq,
  ISaveMeetingReservation,
  IMeetingRoomLocationList,
  ISaveMeetingResBody,
} from 'types/MeetingRoomType'

class MeetingRoomService {
  getMeetingRoomDetailByLocationId(locationId: number) {
    return http.get(`MeetingService/GetByLocationId?locationId=${locationId}`)
  }

  getMeetingRoomLocations() {
    return http.get<IMeetingRoomLocationList[]>(`MeetingService/GetLocationList`)
  }

  getMeetingRoomFilteredList(data: IMeetingRoomFilteredReq) {
    return http.post<IFilteredMeetingRoomList[]>(`MeetingRoom/GetFilteredList`, data)
  }

  getMeetingRoomImage(meetingRoomId: number) {
    return http.get(`MeetingRoom/GetMeetinRoomImageBase64String?meetingRoomId=${meetingRoomId}`)
  }

  getMeetingRoomReservationTableList(data: IGetMeetingRoomTimeTableReq) {
    return http.post(`MeetingRoomReservation/GetTimeTableList`, data)
  }

  saveMeetingRoomReservation(data: ISaveMeetingResBody) {
    return http.post(`MeetingRoomReservation/SaveReservation`, data)
  }

  /* Favorite */
  addMeetingRoomFavorite(roomId: number) {
    return http.get(`FavoriteMeetingRoom/Save?meetingRoomId=${roomId}`)
  }
  removeMeetingRoomFavorite(roomId: number) {
    return http.get(`FavoriteMeetingRoom/Delete?meetingRoomId=${roomId}`)
  }
}

export default new MeetingRoomService()
